import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 40px 0;
`;

const Container = styled.div.attrs({ className: 'app-container' })`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 48px;
`;

const SectionTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 30px;
  margin-top: 20px;
  color: var(--text-color);
`;

const TermsContent = styled.div`
  line-height: 1.6;
  color: var(--text-color);
  margin-bottom: 120px;
  
  h2 {
    font-size: 1.8rem;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  
  h3 {
    font-size: 1.4rem;
    margin-top: 30px;
    margin-bottom: 15px;
  }
  
  p {
    margin-bottom: 20px;
  }
  
  ul {
    margin-bottom: 20px;
    padding-left: 20px;
    list-style-type: disc;
  }
  
  li {
    margin-bottom: 10px;
  }
`;

const TermsPage = () => {
  return (
    <PageContainer>
      <Container>
        <SectionTitle>Terms and Conditions</SectionTitle>

        <TermsContent>
          <p>Last updated: [Date]</p>

          <p>
            Welcome to Interstellar Map ("we", "us", or "our"). These Terms and Conditions ("Terms") govern your access to and use of our website https://interstellarmap.com (the "Site") and the purchase of our products and services.
          </p>

          <p>
            By accessing or using our Site, you agree to be bound by these Terms. If you do not agree, please do not use our Site.
          </p>

          <h2>1. About Us</h2>
          <p>
            Interstellar Map specializes in creating personalized star maps that depict the exact alignment of stars and other celestial objects as seen from a selected location and date. Customers may customize the design and choose to receive either a digital download or a printed product shipped to their address.
          </p>
          <p>Our contact details:</p>
          <ul>
            <li>Email: [info@interstellarmap.com]</li>
            <li>Address: [Insert company registered address here]</li>
          </ul>

          <h2>2. Eligibility</h2>
          <p>By using this Site, you confirm that:</p>
          <ul>
            <li>You are at least 18 years old or have reached the age of majority in your jurisdiction.</li>
            <li>You have the legal capacity to enter into these Terms.</li>
          </ul>

          <h2>3. Orders and Products</h2>
          <h3>3.1 Personalized Products</h3>
          <p>
            Our star maps are customized according to the location, date, and design options provided by you. Please ensure all details entered during the customization process are accurate, as we create each product based on this information.
          </p>

          <h3>3.2 Order Process</h3>
          <ul>
            <li>You may place an order by selecting your customization options and completing checkout.</li>
            <li>By confirming your order, you make a binding offer to purchase.</li>
            <li>A contract is formed once you receive an order confirmation from us by email.</li>
          </ul>

          <h2>4. Prices and Payment</h2>
          <p>Payment is due at the time of ordering.</p>
          <p>We accept MasterCard and VISA</p>

          <h2>5. Delivery</h2>
          <h3>5.1 Digital Products</h3>
          <p>
            Digital star maps will be provided as high-resolution files available for download or sent via email after order confirmation.
          </p>

          <h3>5.2 Printed Products</h3>
          <p>
            Printed star maps will be produced and shipped to the delivery address provided. Estimated delivery times vary by destination and can take up to 15 business days.
          </p>

          <h2>6. Right of Withdrawal (EU Consumers)</h2>
          <h3>6.1 Exclusion for Personalized Products</h3>
          <p>
            Under EU consumer protection laws, the right of withdrawal does not apply to goods made to the consumer's specifications or clearly personalized (Article 16(c) of Directive 2011/83/EU). Because our star maps are customized uniquely for each customer, you do not have a right to cancel or return your order once it has been placed and confirmed.
          </p>

          <h3>6.2 Digital Downloads</h3>
          <p>
            For digital downloads, by purchasing you expressly consent to us beginning the performance of the contract immediately. You acknowledge that you lose your right of withdrawal once the download has started.
          </p>

          <h2>7. Intellectual Property</h2>
          <p>
            All content, designs, and products offered on this Site remain our intellectual property. You may not reproduce, distribute, or use our star maps beyond personal use without our prior written consent.
          </p>

          <h2>8. Warranties and Liability</h2>
          <h3>8.1 Conformity</h3>
          <p>
            We warrant that our products conform to the description on our Site and to your customization inputs.
          </p>

          <h3>8.2 Limitation of Liability</h3>
          <p>
            To the fullest extent permitted by law, we shall not be liable for indirect or consequential losses. Our total liability under these Terms shall not exceed the amount paid by you for the product.
          </p>
          <p>
            Nothing in these Terms limits or excludes our liability for fraud, gross negligence, or any liability that cannot be limited under applicable law.
          </p>

          <h2>9. Data Protection</h2>
          <p>
            Your personal data is processed in accordance with our Privacy Policy, which explains how we collect, store, and use your data.
          </p>

          <h2>10. Governing Law and Jurisdiction</h2>
          <p>
            These Terms are governed by the laws of the United Kingdom.
          </p>

          <h2>11. Changes to These Terms</h2>
          <p>
            We reserve the right to update these Terms. Any changes will be posted on this page and become effective upon posting. Continued use of our Site after changes are posted constitutes acceptance.
          </p>

          <h2>12. Contact Us</h2>
          <p>
            If you have any questions or concerns, please contact us at: 📧 [info@interstellarmap.com]
          </p>
        </TermsContent>
      </Container>
    </PageContainer>
  );
};

export default TermsPage; 